// Zustand store pro navigační kernel

import { createStore } from 'zustand/vanilla';
import type { NavigationState } from './navigationState';
import { createInitialNavigationState } from './navigationState';

export interface NavigationStoreState {
  navigation: NavigationState;
  setNavigation: (state: NavigationState) => void;
}

export function createNavigationStore() {
  return createStore<NavigationStoreState>((set) => ({
    navigation: createInitialNavigationState(),
    setNavigation: (navigation: NavigationState) => set({ navigation }),
  }));
}

export type NavigationStore = ReturnType<typeof createNavigationStore>;
